// features/workstations/components/empty-state.js
// ═══════════════════════════════════════════════════════════
// EMPTY STATE — shown when user has 0 Workstations.
// Full-page hero with "No workstations yet" framing + CTA.
//
// After Tim's 2 seed Workstations load on first sign-in, this
// should rarely appear — it's mostly for users who've deleted
// everything or a fresh deploy without seeds.
// ═══════════════════════════════════════════════════════════

export default function EmptyState({ onCreate }) {
  return (
    <div className="ws-empty">
      <div className="ws-empty-eyebrow">No workstations yet</div>
      <div className="ws-empty-title">Your configured workspaces live here</div>
      <div className="ws-empty-body">
        Each Workstation is a configured workspace for a specific kind of work —
        trading, real estate, writing, research, anything you do regularly.
        <br /><br />
        Setup is a 7-minute conversation, not a form. Shift learns what you do,
        your rules, your criteria. The workstation builds in real time as you talk.
      </div>
      <button type="button" className="ws-empty-cta" onClick={onCreate}>
        + Create your first Workstation
      </button>
    </div>
  );
}
